module.exports = __webpack_public_path__ + "img/questionbankred.91cef62f.svg";